export default {
  en: {
    'pages.upload-data.title-supporting-documents': 'Upload data & supporting documents',
    'pages.upload-data.supporting-documents': 'Supporting documents',
    'pages.upload-data.supporting-documents.upload': 'Upload file',
    'pages.upload-data.supporting-documents.links': 'Links to supporting documents',
    'pages.upload-data.supporting-documents.upload-description':
      'Upon review of your data, your account manager may ask you to upload invoices. If you have any imports then upload them here.',
    'pages.upload-data.title': 'Upload Options',
    'pages.upload-data.upload-data-template-title': 'Upload data template',
    'pages.upload-data.upload-data-template-content':
      'Use the {appName} template to upload your transactional data.',
    'pages.upload-data.upload-data-template-download': 'Download a blank template',
    'pages.upload-data.upload': 'Upload',
    'pages.upload-data.online-spreadsheet-tool-title': 'Online spreadsheet tool',
    'pages.upload-data.online-spreadsheet-tool-content':
      'Copy and paste columns into an online spreadsheet. 500 Rows can be uploaded at a time',
    'pages.upload-data.use-spreadsheet': 'Use Spreadsheet',
    'pages.upload-data.no-transactions-title': 'No transaction to declare',
    'pages.upload-data.no-transactions-content': 'If you have no VAT transactions for the period',
    'pages.upload-data.nil-return': 'Nil Return',
    'pages.upload-data.conversion-tool-tool-title': 'Online conversion tool',
    'pages.upload-data.conversion-tool.conversion.success': 'File converted successfully.',
    'pages.upload-data.conversion-tool.conversion.failure': 'An error occurred. Please try again.',
    'pages.upload-data.conversion-tool-tool-content':
      'Map and convert your transaction data to the {appName} template.',
    'pages.upload-data.fetch-data': 'Fetch Data',
    'pages.upload-data.fetch-data-title': 'Fetch data via API',
    'pages.upload-data.fetch-data-content': 'Amazon, SAP, Oracle, Shopify, Ebay',
    'pages.upload-data.process-data': 'Process Data',
    'pages.upload-data.overwrite-heading':
      'Please note you have already processed data for this filing, by continuing you shall overwrite the existing filing',
    'pages.upload-data.overwrite-data': 'Overwrite Data',
    'pages.upload-data.overwrite-data.cancel': 'Cancel',
    'pages.upload-data.it.use-previous-data.title': 'Use previous data',
    'pages.upload-data.it.use-previous-data.message':
      'Your filing period coincides with your previous VAT returns. You can use this data.',
    'pages.upload-data.it.use-previous-data.button': 'Use VAT Returns',
    'pages.upload-data.it.filing-status': 'Filing Status',
    'pages.upload-data.it.included-return': 'Filing Included',
    'pages.upload-data.it.yes': 'Yes',
    'pages.upload-data.it.no': 'No',
    'pages.upload-data.conversion-tool.find-out-more': 'Find out more',
    'pages.upload-data.conversion-tool': 'Online conversion',
    'pages.upload-data.conversion-tool.empty-table':
      'The sheet is empty or data starts at rows above specified.',
    'pages.upload-data.conversion-tool.placeholder': 'Select mapping',
    'pages.upload-data.mapping.mapping-name': 'Mapping name:',
    'pages.upload-data.mapping.data-start': 'Data starts on row:',
    'pages.upload-data.mapping.header-start': 'Headers start on row:',
    'pages.upload-data.mapping.refresh': 'Refresh',
    'pages.upload-data.mapping.cancel': 'Cancel',
    'pages.upload-data.mapping.save': 'Save and exit',
    'pages.upload-data.mapping.title': 'Online Conversion: Manual Setup',
    'pages.upload-data.mapping.step-1': 'Step 1 of 4',
    'pages.upload-data.mapping.step-2': 'Step 2 of 4',
    'pages.upload-data.mapping.step-3': 'Step 3 of 4',
    'pages.upload-data.mapping.step-4': 'Step 4 of 4',
    'pages.upload-data.mapping.mapping-allocation': 'Mapping Allocation',
    'pages.upload-data.mapping.confirm-fields':
      'Confirm that you have these fields in your spreadsheet',
    'pages.upload-data.mapping.step-one.sub-heading':
      'Use the options below to specify how the sheet data will be converted for use in {appName}.',
    'pages.upload-data.mapping.step-one.heading': 'Define how your data will be converted',
    'pages.upload-data.mapping.confirm': 'Confirm',
    'pages.upload-data.mapping.check-headers-exist-title': 'Do your columns have header names?',
    'pages.upload-data.mapping.check-rows-title': 'What row does your data start on?',
    'pages.upload-data.mapping.check-headers-title': 'Where headers start on?',
    'pages.upload-data.mapping.error-title':
      'You cannot proceed without the following columns of data:',
    'pages.upload-data.mapping.error-subtitle': 'Please map the following required columns.',
    'pages.upload-data.mapping.back': 'Back',
    'pages.upload-data.mapping.select.label': 'Select match',
    'pages.upload-data.mapping.matched': 'Matched',
    'pages.upload-data.mapping.unmatched': 'Unmatched',
    'pages.upload-data.mapping.placeholder.row': 'Enter row number',
    'pages.upload-data.mapping.placeholder.header': 'Enter header number',
    'pages.upload-data.mapping.placeholder.no-headers': 'No Headers',
    'pages.upload-data.mapping.placeholder.name': 'Enter mapping name',
    'pages.upload-data.mapping.placeholder.select-fields': 'Select fields',
    'pages.upload-data.conversion-tool.table-fetching-error':
      'You have entered an incorrect row or header position.',
    'pages.upload-data.mapping.tooltip.select-fields':
      'Please select the mandatory fields to continue',
    'pages.upload-data.mapping.tooltip.enter-name': 'Please enter mapping name',
    'pages.upload-data.mapping.selectbox.reset': 'Reset selected item',
    'pages.upload-data.conversion-tool.uploaded': 'Upload successful',
    'pages.upload-data.upload-failure': 'Upload failed. Please try again! {error}',
    'pages.upload-data.use-previous-data-content':
      'Your filing period coincides with your VAT returns. You can use this data.',
    'pages.upload-data.use-vat-returns': 'Use VAT Returns',
    'pages.upload-data.use-previous-data-title': 'Use VAT return data',
    'pages.upload-data.processing-error': 'Failed to process data',
  },
};
